module.exports = __webpack_public_path__ + "img/style_3_4.3737d929.png";